export enum TabName {
  DRAFT = 'draft',
  ORDERS = 'orders',
}
